import { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Select,
  Button,
  useToast,
} from "@chakra-ui/react";
import { useClinic } from "../../../../components/Context/ClinicaContext";
import { useImportarTabelaProcedimento } from "../hooks/useTabelaProcedimento";

import { parseCsvText } from "../utils/importarCsv";

const ImportarTabelaModal = ({ isOpen, onClose, tipoPadrao = "convenio" }) => {
  const { selectedClinic } = useClinic();
  const toast = useToast();
  const importarTabela = useImportarTabelaProcedimento();

  const [nomeTabela, setNomeTabela] = useState("");
  const [tipoTabelaImport, setTipoTabelaImport] = useState(tipoPadrao);
  const [selectedFile, setSelectedFile] = useState(null);

  const resetForm = () => {
    setNomeTabela("");
    setTipoTabelaImport(tipoPadrao);
    setSelectedFile(null);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleImportar = () => {
    if (!selectedClinic?._id) {
      toast({ title: "Erro", description: "Selecione uma clínica para importar a tabela.", status: "error", duration: 3000, isClosable: true });
      return;
    }
    if (!selectedFile) {
      toast({ title: "Erro", description: "Nenhum arquivo selecionado.", status: "error", duration: 3000, isClosable: true });
      return;
    }
    if (!nomeTabela.trim()) {
      toast({ title: "Erro", description: "Por favor, dê um nome para esta tabela.", status: "error", duration: 3000, isClosable: true });
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const procedimentos = parseCsvText(e.target.result);
        importarTabela.mutate(
          {
            tabelaProcedimentos: procedimentos,
            nomeTabela: nomeTabela.trim(),
            tipoTabelaProcedimento: tipoTabelaImport,
            clinica: selectedClinic._id,
          },
          { onSuccess: handleClose }
        );
      } catch (error) {
        toast({ title: "Importação não realizada", description: error.message, status: "error", duration: 7000, isClosable: true });
      }
    };
    reader.onerror = () => toast({ title: "Não foi possível ler o arquivo", status: "error", isClosable: true });
    reader.readAsText(selectedFile);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Carregar tabela de procedimentos</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl mb={4} isRequired>
            <FormLabel>Nome da tabela</FormLabel>
            <Input value={nomeTabela} onChange={(e) => setNomeTabela(e.target.value)} placeholder="Ex: Unimed 2025" />
          </FormControl>
          <FormControl mb={4} isRequired>
            <FormLabel>Flag (uso)</FormLabel>
            <Select value={tipoTabelaImport} onChange={(e) => setTipoTabelaImport(e.target.value)}>
              <option value="convenio">Somente Convênio</option>
              <option value="particular">Somente Particular</option>
              <option value="ambos">Convênio e Particular</option>
            </Select>
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Arquivo CSV</FormLabel>
            <Input type="file" accept=".csv" onChange={(e) => setSelectedFile(e.target.files[0])} />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={handleClose}>
            Cancelar
          </Button>
          <Button colorScheme="blue" onClick={handleImportar} isLoading={importarTabela.isPending}>
            Importar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ImportarTabelaModal;
